<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-card header-tag="header" footer-tag="footer">
        <div slot="header">
          <i class="fa fa-share-alt"></i
          ><strong>
            Proceso #{{ $route.params.number }}
            <b-spinner v-if="loading" class="float-right" small></b-spinner>
          </strong>
        </div>
        <b-row>
          <b-col class="mb-3">
            <main-buttons @add-rows-in="addRowsIn($event)" />
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <content-table
              :title="'Pallets/Bins Volteados'"
              :items="contents_in"
              :footers="footers_in"
              :table_type="0"
              @delete-row="deleteRow($event)"
              :fields="fields_in"
            />
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <h3>Lotes en Proceso</h3>
            <lot-list></lot-list>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <content-table
              :title="'Pallets/Bins Resultantes'"
              @delete-row="deleteRow($event)"
              :footers="footers_out"
              :table_type="1"
              :items="contents_out"
              :fields="fields_out"
            />
          </b-col>
        </b-row>
        <b-row>
          <b-col class="mb-3">
            <b-button
              variant="primary"
              type="submit"
              :disabled="loading"
              class="float-right"
              @click="onSubmit"
            >
              <span class="mr-1">Cerrar Proceso</span>
              <b-spinner
                v-if="loading"
                variant="light"
                class="float-right"
                small
              ></b-spinner>
            </b-button>
          </b-col>
        </b-row>
      </b-card>
    </div>
  </div>
</template>

<script>
import MainButtons from "./MainButtons";
import ContentTable from "./ContentTable";
import LotList from "./LotList";
import { bus } from "../../../main";

import { mapState, mapGetters } from "vuex";

export default {
  name: "Main",
  components: {
    MainButtons,
    ContentTable,
    LotList
  },
  computed: {
    ...mapState("bagnoProcessModule", {
      contents_in: state => state.form.contents_in,
      contents_out: state => state.form.contents_out
    }),
    ...mapGetters("bagnoProcessModule", [
      "totalInNet",
      "totalOutNet",
      "totalInGross",
      "totalOutGross",
      "totalInQuantity",
      "totalOutQuantity",
      "differenceNet"
    ]),
    footers_in() {
      return {
        net_kilograms: this.totalInNet,
        gross_kilograms: this.totalInGross,
        quantity: this.totalInQuantity
      };
    },
    footers_out() {
      return {
        net_kilograms: this.totalOutNet,
        gross_kilograms: this.totalOutGross,
        quantity: this.totalOutQuantity
      };
    }
  },
  created() {
    this.getProcess(this.$route.params.id);
  },
  destroyed() {
    this.$store.commit("bagnoProcessModule/cleanProcess");
  },
  data() {
    return {
      title: "Ingreso",
      loading: false,
      fields_in: [
        { key: "number", label: "#" },
        { key: "lot", label: "Lote" },
        { key: "product_code", label: "Código" },
        { key: "product_name", label: "Glosa" },
        {
          key: "quantity",
          label: "Cantidad",
          tdClass: "text-right",
          thClass: "text-right"
        },
        {
          key: "net_kilograms",
          label: "KN",
          tdClass: "text-right",
          thClass: "text-right"
        },
        {
          key: "action",
          label: "",
          tdClass: "text-right",
          thClass: "text-right"
        }
      ],
      fields_out: [
        { key: "number", label: "#" },
        { key: "lot", label: "Lote" },
        { key: "product_code", label: "Código" },
        { key: "product_name", label: "Glosa" },
        {
          key: "selling_format",
          label: "Formato Vta",
          tdClass: "text-left",
          thClass: "text-left"
        },
        {
          key: "quantity",
          label: "Cantidad",
          tdClass: "text-right",
          thClass: "text-right"
        },
        {
          key: "net_kilograms",
          label: "KN",
          tdClass: "text-right",
          thClass: "text-right"
        },
        {
          key: "action",
          label: "",
          tdClass: "text-right",
          thClass: "text-right"
        }
      ]
    };
  },
  methods: {
    onSubmit() {
      if (parseFloat(this.differenceNet) == 0) {
        this.$swal
          .fire({
            title: "Seguro que quieres cerrar el proceso?",
            text: "",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            cancelButtonText: "No",
            confirmButtonText: "SI"
          })
          .then(result => {
            if (result.value) {
              this.closeProcess(this.$route.params.id);
            }
          });
      } else {
        this.$toast.info(
          "Por favor la diferencia debe ser 0 para poder cerrar",
          ""
        );
      }
    },
    async closeProcess(evt) {
      const thisV = this;
      thisV.loading = true;
      try {
        const response = await thisV.$axios({
          method: "POST",
          url: `bagno/process/${evt}/close_process/`
        });
        thisV.$toast.success(
          `Proceso #${response.data.number} terminado con éxito`,
          ""
        );
        thisV.$router.push({ name: "bagno-procesos-listado" });
      } catch (error) {
        console.log(error);
        thisV.$toast.error("Problemas al terminar proceso", "");
        thisV.loading = false;
      }
    },
    async getProcess(evt) {
      const thisV = this;
      let url = "";
      thisV.loading = true;
      url = `bagno/process/${evt}/detailed_process/`;
      try {
        const response = await thisV.$axios({
          method: "GET",
          url: url
        });
        thisV.$store.commit("bagnoProcessModule/updateProcess", response.data);
        thisV.$toast.success(`Proceso #${evt} cargado con éxito`, "");
        thisV.loading = false;
      } catch (error) {
        console.log(error);
        thisV.$toast.error("Problemas al cargar proceso", "");
        thisV.loading = false;
      }
    },
    async addRowsIn(e) {
      const thisV = this;
      thisV.loading = true;
      try {
        const response = await thisV.$axios({
          method: "POST",
          url: `bagno/content/${e.content_id}/traceability_in/`,
          data: {
            process_id: thisV.$route.params.id,
            quantity: parseInt(e.quantity),
            net_kilograms: parseFloat(e.net_kilograms),
            gross_kilograms: parseFloat(e.gross_kilograms),
            type_income: e.type_income
          }
        });
        if (response.data.exist === true) {
          if (thisV.contents_in.find(x => x.id === response.data.id) == null) {
            thisV.$store.commit("bagnoProcessModule/addRowsIn", response.data);
            thisV.$toast.success("Agregado con éxito", "");
            thisV.loading = false;
          } else {
            thisV.$toast.error("Este objeto ya fue ingresado", "");
            thisV.loading = false;
          }
          bus.$emit("refreshStockListProcess");
        } else {
          thisV.$toast.error("Este objeto no existe", "");
          thisV.loading = false;
        }
      } catch (error) {
        console.log(error);
        this.$toast.error(error.response.data.detail, "");
        thisV.loading = false;
      }
    },
    async deleteRow(evt) {
      const thisV = this;
      let url = "";
      thisV.loading = true;
      if (evt.table === 0) {
        let indice2 = this.contents_out.findIndex(
          data => data.lot_id === evt.item.lot_id
        );
        if (indice2 >= 0) {
          thisV.loading = false;
          this.$swal.fire(
            "Para realizar esta operación debe eliminar primero los bins y palles resultantes del lote " +
              evt.item.lot,
            "",
            "error"
          );
        } else {
          url = `bagno/process/${evt.item.id}/delete_trace_in/`;
          try {
            const response = await thisV.$axios({
              method: "POST",
              url: url,
              data: { process_id: thisV.$route.params.id }
            });
            thisV.$store.commit("bagnoProcessModule/deleteRow", {
              table_type: evt.table,
              item: response.data,
              index: evt.index
            });
            thisV.$toast.success("Eliminado con éxito", "");
            thisV.loading = false;
          } catch (error) {
            console.log(error);
            thisV.$toast.error("Problemas al eliminar item", "");
            thisV.loading = false;
          }
        }
      } else {
        url = `bagno/process/${evt.item.id}/delete_trace_out/`;

        try {
          const response = await thisV.$axios({
            method: "POST",
            url: url,
            data: { process_id: thisV.$route.params.id }
          });
          thisV.$store.commit("bagnoProcessModule/deleteRow", {
            table_type: evt.table,
            item: response.data,
            index: evt.index
          });
          thisV.$toast.success("Eliminado con éxito", "");
          thisV.loading = false;
        } catch (error) {
          console.log(error);
          thisV.$toast.error("Problemas al eliminar item", "");
          thisV.loading = false;
        }
      }
    }
  }
};
</script>

<style scoped></style>
